import React, { useEffect, useRef, useState } from 'react';
import * as echarts from 'echarts';

const atributos = ['Confidencialidad', 'Integridad', 'Disponibilidad'];

// 🔢 Función para formatear números grandes
const formatNumber = (value) => {
  if (value >= 1e9) return (value / 1e9).toFixed(1) + "B";
  if (value >= 1e6) return (value / 1e6).toFixed(1) + "M";
  if (value >= 1e3) return (value / 1e3).toFixed(1) + "K";
  return value;
};

const getOption = (percentil, resumen) => {
  const keyCon = `aporte_control_${percentil.toLowerCase()}_introducir`;
  const keySin = `aporte_control_${percentil.toLowerCase()}_total`;
  const keyDif = `diferencia_${percentil.toLowerCase()}`;

  const con = atributos.map(attr => resumen[attr]?.[keyCon] ?? 0);
  const sin = atributos.map(attr => resumen[attr]?.[keySin] ?? 0);
  const dif = atributos.map(attr => resumen[attr]?.[keyDif] ?? 0);

  return {
    tooltip: {
      trigger: 'axis',
      axisPointer: { type: 'shadow' },
      formatter: (params) => {
        // 🔹 Formatea los valores en el tooltip
        return params
          .map(p => `${p.seriesName}: ${formatNumber(p.value)}`)
          .join('<br/>');
      }
    },
    legend: {
      top: 0
    },
    grid: {
      left: '5%',
      right: '5%',
      bottom: '5%',
      containLabel: true
    },
    xAxis: {
      type: 'value',
      axisLabel: {
        formatter: (value) => formatNumber(value)
      }
    },
    yAxis: {
      type: 'category',
      data: atributos,
      inverse: true
    },
    series: [
      {
        name: 'Sin Vulnerabilidades',
        type: 'bar',
        data: sin,
        label: {
          show: true,
          position: 'right',
          formatter: (p) => formatNumber(p.value)
        }
      },
      {
        name: 'Con Vulnerabilidades',
        type: 'bar',
        data: con,
        label: {
          show: true,
          position: 'right',
          formatter: (p) => formatNumber(p.value) // 🔹 Formatea etiquetas
        }
      },
      {
        name: 'Diferencias',
        type: 'bar',
        data: dif,
        label: {
          show: true,
          position: 'right',
          formatter: (p) => formatNumber(p.value)
        }
      }
    ]
  };
};

const GraficaSuciaLimpia = ({ resumen }) => {
  const [percentil, setPercentil] = useState('p50');
  const chartRef = useRef(null);

  useEffect(() => {
    const chartDom = document.getElementById("grafica-sucia-limpia");
    if (!chartDom) return;
    const myChart = echarts.init(chartDom);
    myChart.setOption(getOption(percentil, resumen));
    const resizeHandler = () => myChart.resize();
    window.addEventListener('resize', resizeHandler);
    return () => {
      window.removeEventListener('resize', resizeHandler);
      myChart.dispose();
    };
  }, [percentil, resumen]);

  return (
    <div>
      <div style={{ marginBottom: 20 }}>
        <label>Selecciona percentil: </label>
        <select
          value={percentil}
          onChange={(e) => setPercentil(e.target.value)}
        >
          <option value="p50">P50</option>
          <option value="p95">P95</option>
          <option value="p99">P99</option>
        </select>
      </div>

      <div id="grafica-sucia-limpia" style={{ width: "100%", height: "400px" }} />
    </div>
  );
};

export default GraficaSuciaLimpia;